export default "__VITE_ASSET__QHBi4Xa1__"